import { render } from "./TestResultGuideForEduProduct.vue?vue&type=template&id=c30e3d40&scoped=true"
import script from "./TestResultGuideForEduProduct.vue?vue&type=script&lang=js"
export * from "./TestResultGuideForEduProduct.vue?vue&type=script&lang=js"

import "./TestResultGuideForEduProduct.vue?vue&type=style&index=0&id=c30e3d40&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c30e3d40"]])

export default __exports__